import { FC, PropsWithChildren } from 'react';
import {
  StyledTemplateCardTitle,
  StyledPrGTemplateCardWrapper,
} from 'modules/predictiveGoals/components/Styled';
import { LikelyToChurn, LikelyToMakeAPurchase, LikelyToSubscribe } from 'ui/illustrations';
import { InternalTemplates } from 'modules/predictiveGoals/types';
import { TopTooltip } from 'ui/tooltip';
import { colors } from 'ui/theme';
import {
  TemplateSectionCard,
  TemplateSectionCardIconContainer,
  TemplateSectionCardTextContainer,
  TemplateSectionCardDetails,
} from './TemplateSection.styles';
import {
  INITIAL_PAGE_DISABLED_TEMPLATE_TEXT,
  PREDICTIVE_GOALS_LIKELY_TO_ENGAGE_DETAILS,
  PREDICTIVE_GOALS_LIKELY_TO_ENGAGE,
  PREDICTIVE_GOALS_LIKELY_TO_CHURN_DETAILS,
  PREDICTIVE_GOALS_LIKELY_TO_PURCHASE_DETAILS,
  PREDICTIVE_GOALS_LIKELY_TO_CHURN,
  PREDICTIVE_GOALS_LIKELY_TO_PURCHASE,
} from '../../../constants';

export interface FullTemplateCardProps {
  children?: React.ReactNode;
  isDisabled?: boolean;
  onTemplateSelection: (templateType: InternalTemplates) => void;
  templateType: InternalTemplates;
}

export const TemplateTypeStyleConfig = {
  [InternalTemplates.ENGAGE]: {
    body: PREDICTIVE_GOALS_LIKELY_TO_ENGAGE_DETAILS,
    cardId: 'full-template-card-subscribe',
    color: colors.mustard10,
    Icon: LikelyToSubscribe,
    title: PREDICTIVE_GOALS_LIKELY_TO_ENGAGE,
  },
  [InternalTemplates.CHURN]: {
    body: PREDICTIVE_GOALS_LIKELY_TO_CHURN_DETAILS,
    cardId: 'full-template-card-churn',
    color: colors.purple10,
    Icon: LikelyToChurn,
    title: PREDICTIVE_GOALS_LIKELY_TO_CHURN,
  },
  [InternalTemplates.PURCHASE]: {
    body: PREDICTIVE_GOALS_LIKELY_TO_PURCHASE_DETAILS,
    cardId: 'full-template-card-purchase',
    color: colors.cyan10,
    Icon: LikelyToMakeAPurchase,
    title: PREDICTIVE_GOALS_LIKELY_TO_PURCHASE,
  },
};

export const FullTemplateCard: FC<PropsWithChildren<FullTemplateCardProps>> = ({
  isDisabled = false,
  onTemplateSelection,
  templateType,
}) => {
  const { body, cardId, color, Icon, title } = TemplateTypeStyleConfig[templateType];
  return (
    <StyledPrGTemplateCardWrapper>
      <TopTooltip tooltipContent={INITIAL_PAGE_DISABLED_TEMPLATE_TEXT} isEnabled={isDisabled}>
        <TemplateSectionCard
          data-test={cardId}
          data-disabled={isDisabled}
          onClick={() => {
            if (isDisabled) return;
            onTemplateSelection(templateType);
          }}
        >
          <TemplateSectionCardIconContainer $color={color}>
            <Icon />
          </TemplateSectionCardIconContainer>
          <TemplateSectionCardTextContainer>
            <StyledTemplateCardTitle>{title}</StyledTemplateCardTitle>
            <TemplateSectionCardDetails>{body}</TemplateSectionCardDetails>
          </TemplateSectionCardTextContainer>
        </TemplateSectionCard>
      </TopTooltip>
    </StyledPrGTemplateCardWrapper>
  );
};
